import { Link } from 'react-router-dom'

import damping from '@/assets/images/services/damping.webp'
import { Button } from '@/components/button'
import { ProtectionIcon } from '@/components/icons/services/damping/protection'
import { SponsorshipTotalIcon } from '@/components/icons/services/damping/sponsorship-total'
import { DefaultsEsgIcon } from '@/components/icons/services/defaults-esg'
import { SatelliteTechnologyIcon } from '@/components/icons/services/satellite-technology'

import * as Card from '../../components/services-sections/card'
import * as Section from '../../components/services-sections/root'

export function DampingSection() {
  return (
    <section className="flex flex-col">
      <Section.ContainerRoot>
        <Section.Image src={damping} />
        <Section.Container>
          <Section.Title>Amortecimento</Section.Title>
          <Section.Description>
            <Section.DescriptionBold>
              Escudos estratégicos para proteger os tesouros naturais do Brasil.
            </Section.DescriptionBold>{' '}
            Zonas-tampão inteligentes para preservar ecossistemas, conectar
            paisagens e garantir a resiliência ecológica com tecnologia de
            ponta.
          </Section.Description>
        </Section.Container>
      </Section.ContainerRoot>

      <div className="flex flex-col gap-24">
        <Card.Scroll>
          {/* Card 1 */}
          <Card.Root>
            <Card.Container icon={ProtectionIcon}>
              <Card.Description>
                Proteção vital para{' '}
                <Card.DescriptionBold>
                  parques, nascentes e terras indígenas
                </Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 2 */}
          <Card.Root>
            <Card.Container icon={SatelliteTechnologyIcon}>
              <Card.Description>
                Monitoramento de precisão com{' '}
                <Card.DescriptionBold>
                  satélites e blockchain
                </Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 3 */}
          <Card.Root>
            <Card.Container icon={DefaultsEsgIcon}>
              <Card.Description>
                Impacto direto na{' '}
                <Card.DescriptionBold>
                  conservação e no ESG
                </Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 4 */}
          <Card.Root>
            <Card.Container icon={SponsorshipTotalIcon}>
              <Card.Description>
                Projetos disponíveis para patrocínio com{' '}
                <Card.DescriptionBold>total transparência</Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>
        </Card.Scroll>
        <Button
          asChild
          className="mx-auto max-w-96 uppercase md:w-full"
          disabled
        >
          <Link to="/damping">Saiba mais</Link>
        </Button>
      </div>
    </section>
  )
}
